import { Moment } from 'moment';
import { dataMember, required, typedArray } from 'santee-dcts';
import { deserializers } from '../../../core/deserializers';
import { EQueryEscalationLevel } from './e-query-escalation-level';

export class AdminEQueryEscalation {
    @dataMember()
    @required()
    public email: string;

    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required()
    public accessionNumber: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public escalationSentTime: Moment;

    @dataMember()
    @required()
    public escalationLevel: EQueryEscalationLevel;

    @dataMember()
    @required({ nullable: true })
    public escalationAttempt: number;

    @dataMember()
    @required()
    public escalationId: number;
}

export class AdminEQueryEscalationsReadModel {
    @dataMember()
    @typedArray(AdminEQueryEscalation)
    @required()
    public escalations: AdminEQueryEscalation[];
}